import "./sidebar.css";
import { Link } from 'react-router-dom';
import { CiUser, CiDeliveryTruck } from "react-icons/ci";
import { MdOutlineCircleNotifications } from "react-icons/md";
import { MdEdit, MdPendingActions } from "react-icons/md";
import { useAuthContext } from '../../../hooks/useAuthContext';
import { BiDollar, BiLogOut } from 'react-icons/bi';

function SideBar({ setExpended, expended }) {
    const handleToggle = () => {
        setExpended(!expended);
    };

    const { dispatch, auth } = useAuthContext();

    const handleLogOut = async () => {
        try {
          // Dispatch the LOGOUT action to update the app state
          dispatch({ type: 'LOGOUT' });
      
          // Remove the auth data from localStorage
          localStorage.removeItem('authMandoub');
      
          console.log('Logged out successfully');
        } catch (err) {
          console.error('Error during logout:', err);
        }
      };

    return (
        <div id="nav-bar">
            <input id="nav-toggle" onClick={handleToggle} type="checkbox" />
            <div id="nav-header">
                <a id="nav-title" href="#" target="_blank">
                    <i className="fab fa-codepen"></i>الرحيق
                </a>
                <label htmlFor="nav-toggle">
                    <span id="nav-toggle-burger"></span>
                </label>
                <hr />
            </div>
            <div id="nav-content">
                <Link to="/" className="nav-button">
                    <CiUser className='fas' />
                    <span>الملف الشخصي</span>
                </Link>
                <Link to="notifications" className="nav-button notif-btn">
                    <MdOutlineCircleNotifications className="fas" />
                    <span>الإشعارات</span>

                </Link>
                <Link to="/orders" className="nav-button">
                    <CiDeliveryTruck className="fas" />
                    <span>طلبات جديدة</span>
                </Link>
                <hr />
                <Link to="/transactions" className="nav-button">
                    <BiDollar className="fas" />
                    <span>المالية</span>
                </Link>
                <Link to="/reviews" className="nav-button">
                    <MdPendingActions className="fas" />
                    <span>المراجعات</span>
                </Link>
                <Link to="/edit" className="nav-button">
                    <MdEdit className="fas" />
                    <span>تعديل الملف الشخصي</span>
                </Link>
                <hr />
                <Link className="nav-button" onClick={handleLogOut}>
                    <BiLogOut className="fas" />
                    <span>الخروج</span>
                </Link>
                <div id="nav-content-highlight"></div>
            </div>
            <input id="nav-footer-toggle" type="checkbox" />
            <div id="nav-footer">
                <div id="nav-footer-heading">
                    <div id="nav-footer-avatar">
                    <img src={auth?.user.img? process.env.REACT_APP_UPLOADS_DIR+auth?.user.img : "/img/default.png"} alt="" />
                    </div>
                    <div id="nav-footer-titlebox">
                        <div id="nav-footer-title">
                        {auth?.user.fullName}
                        </div>
                        <span id="nav-footer-subtitle">{auth?.user.area}</span>
                    </div>
                    <label htmlFor="nav-footer-toggle">
                        <i className="fas fa-caret-up"></i>
                    </label>
                </div>
                <div id="nav-footer-content">
                    <p>
                    أحد مسئولي محافظة {auth?.user.area}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SideBar